<template>
    <link :href="'/css/kiosk/stores/'+this.$root.store_uid+'/app.css?v='+Date.now()" rel="stylesheet">

    <header class="d-block w-100 p-0" id="main-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 p-0" id="pub" v-if="this.$root.store_uid !== 'configuration'">
                    <header-banners-component ref="Kiosk" />
                </div>
            </div>
        </div>
    </header>
    <loading-and-errors-component />
    <div class="print_block" id="print_block" ref="print_block" v-if="this.$root.invoice_loaded === true">
        <invoice-template1  v-bind:invoice="this.$root.invoice" />
    </div>
    <AdminHome v-if="this.$root.admin_show === true" />
    <router-view @send="receive"></router-view>
</template>

<script>
import HeaderBanners from "../banners/HeaderBanners";
import Home from "../home/Home";
import { defineComponent } from "vue";
import LoadingAndErrors from "../others/LoadingAndErrors";
import AdminHome from "../admin/AdminHome";
import InvoiceTemplate1 from "../invoices/template1";

export default defineComponent({
    name: "Kiosk",

    components: {
        'header-banners-component': HeaderBanners,
        'home-component': Home,
        'loading-and-errors-component': LoadingAndErrors,
        AdminHome,
        'invoice-template1': InvoiceTemplate1,
    },

    methods: {
        receive(sent_data)
        {
            if(sent_data === 'switch_locale:en')
            {
                window.locale = this.locale = 'en';
            }
            else if(sent_data === 'switch_locale:fr') {
                window.locale = this.locale = 'fr';
            }

            this.$forceUpdate();
        },
    },
})
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s ease;
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
</style>
